export const introData = {
  label: "ABOUT ME",

  left: {
    text:
      "Frontend developer working primarily with React and Angular. I enjoy building complex problem-solving systems and workflows. Strong UI UX foundation but more driven by logic heavy products than visuals. Always learning beyond frontend and drawn to fast paced startup environments where ownership and impact matter."
  },

  right: {
    listItems: [
      {
        icon: "graduation-cap",
        title: "College",
        value: "B Tech. Computer Science, VIT Vellore"
      },
      {
        icon: "location-dot",
        title: "Location",
        value: "Kochi, Kerala"
      }],
      iconItems: [
      {
        icon: "linkedin",
        title: "LinkedIn",
        value: "linkedin.com/in/diyajcyriac",
        link: "https://linkedin.com/in/diyajcyriac",
        type: "brand"
      },
      {
        icon: "github",
        title: "GitHub",
        value: "github.com/diyajcyriac",
        link: "https://github.com/diyajcyriac",
        type: "brand"
      },
    //   {
    //     icon: "file-lines",
    //     title: "Resume",
    //     value: "Download Resume",
    //     link: "/resume.pdf"
    //   },
    //   {
    //     icon: "phone",
    //     title: "Phone",
    //     value: "+91 7902355430"
    //   }
    ]
  }
};